import { RawHtml } from '@divlab/divanui';

import styles from './Description.module.css';
import useTranslation from '@Queries/useTranslation';

import type { FC, HTMLAttributes } from 'react';

const Description: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { t } = useTranslation();

  return (
    <div {...props}>
      <RawHtml className={styles.description} html={t('description')} />
    </div>
  );
};

export default Description;
